<!-- Root Vue component -->
<template>
  <v-app>
    <!-- Tenant bootstrap: show loading until validated, then error screen or app -->
    <template v-if="tenantStore.isTenantPending">
      <div class="tenant-bootstrap-loading">
        <v-progress-circular indeterminate color="primary" size="48" />
        <p class="text-body-2 mt-4">{{ $t('app.messages.loading') }}</p>
      </div>
    </template>
    <template v-else-if="tenantStore.isTenantInvalid">
      <TenantErrorPage />
    </template>
    <template v-else>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </template>
    <app-notifier />
    <app-loader />
  </v-app>
</template>

<script setup>
import { onMounted } from 'vue';
import AppNotifier from '@/components/system/AppNotifier.vue';
import AppLoader from '@/components/system/AppLoader.vue';
import TenantErrorPage from '@/pages/tenant/TenantErrorPage.vue';
import { useProjectConfig } from '@/composables/useProjectConfig';
import { useTenantStore } from '@/stores/tenant';

const tenantStore = useTenantStore();

// Load project config and apply palette to Vuetify theme
useProjectConfig();

onMounted(() => {
  if (tenantStore.isTenantPending) {
    void tenantStore.bootstrap();
  }
});
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: rgb(var(--v-theme-on-surface));
}

.tenant-bootstrap-loading {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}
</style>
